/* script */
//
//
//
//
//

const __vue_script__ = {
	name: "card",
	props: {
		label: String,
		fieldname: String,
		fieldtype: String,
		parent: String,
		reference: String,
		function: String,
		selectedPills: Array
	},
	data() {
		return {
			selected: false
		}
	},
	computed: {
		pillStyle() {
			return (this.selected === true) ? "selectable-badge" : ""
		}
	},
	methods: {
		clicked() {
			this.selected = !this.selected;

			if (this.selected === true){
				this.selectedPills.push({
					fieldname: this.fieldname,
					label: this.label,
					fieldtype: this.fieldtype,
					parent: this.parent,
					reference: this.reference,
					function: this.function
				})
			} else {
				const removeIndex = this.selectedPills.map(function(item) { return item.fieldname; }).indexOf(this.fieldname);
				this.selectedPills.splice(removeIndex, 1);
			}
		}
	}
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "badge align-middle align-text-top align-text-bottom",
      class: _vm.pillStyle,
      on: { click: _vm.clicked }
    },
    [_vm._v("\n\t" + _vm._s(_vm.label) + "\n")]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-2d946a9e_0", { source: "\n.badge {\n\tcursor: pointer;\n}\n.selectable-badge {\n\tbackground-color: #6195FF;\n\tcolor: #fff;\n}\n\n", map: {"version":3,"sources":["frappe/public/js/frappe/form/controls/template_field_selector/FieldPill.vue"],"names":[],"mappings":";AAiDA;CACA,eAAA;AACA;AAEA;CACA,yBAAA;CACA,WAAA;AACA","file":"FieldPill.vue","sourcesContent":["<template>\n\t<div class=\"badge align-middle align-text-top align-text-bottom\" :class=\"pillStyle\" v-on:click=\"clicked\">\n\t\t{{label}}\n\t</div>\n</template>\n<script>\nexport default {\n\tname: \"card\",\n\tprops: {\n\t\tlabel: String,\n\t\tfieldname: String,\n\t\tfieldtype: String,\n\t\tparent: String,\n\t\treference: String,\n\t\tfunction: String,\n\t\tselectedPills: Array\n\t},\n\tdata() {\n\t\treturn {\n\t\t\tselected: false\n\t\t}\n\t},\n\tcomputed: {\n\t\tpillStyle() {\n\t\t\treturn (this.selected === true) ? \"selectable-badge\" : \"\"\n\t\t}\n\t},\n\tmethods: {\n\t\tclicked() {\n\t\t\tthis.selected = !this.selected;\n\n\t\t\tif (this.selected === true){\n\t\t\t\tthis.selectedPills.push({\n\t\t\t\t\tfieldname: this.fieldname,\n\t\t\t\t\tlabel: this.label,\n\t\t\t\t\tfieldtype: this.fieldtype,\n\t\t\t\t\tparent: this.parent,\n\t\t\t\t\treference: this.reference,\n\t\t\t\t\tfunction: this.function\n\t\t\t\t})\n\t\t\t} else {\n\t\t\t\tconst removeIndex = this.selectedPills.map(function(item) { return item.fieldname; }).indexOf(this.fieldname);\n\t\t\t\tthis.selectedPills.splice(removeIndex, 1);\n\t\t\t}\n\t\t}\n\t}\n};\n</script>\n<style>\n.badge {\n\tcursor: pointer;\n}\n\n.selectable-badge {\n\tbackground-color: #6195FF;\n\tcolor: #fff;\n}\n\n</style>"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "frappe/public/js/frappe/form/controls/template_field_selector/FieldPill.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__